export const TIPO_IMPORTACION_ASIENTO = {
  LIBRO_IVA_SAGE: 1,
} as const

export type TipoImportacionAsientoType =
  (typeof TIPO_IMPORTACION_ASIENTO)[keyof typeof TIPO_IMPORTACION_ASIENTO]
